<template>
  <div class="home" v-bind:class="{'forecastShown':showForecast}">
      <home-weather v-bind:show-forecast="showForecast" v-bind:toggle-forecast="toggleForecast"></home-weather>
  
      <div id="cards" class="cards" @scroll="handleScroll">
      	<home-card-list></home-card-list>
        <footer>
          <p>PRODUCT OF ETHEKWINI MUNICIPALITY</p>
          <a href="http://flickr.com/" target="_blank" class="flickr"><i class="icon-flickr"></i></a>
        </footer>
      </div>
      <a @click="scrollTop()" class="btn btn-primary scrollTop">Back to top</a>
  </div>
</template>

<script>
import HomeCardList from '../components/home/HomeCardList'
import HomeWeather from '../components/home/HomeWeather'
import FilterButtons from '../components/home/HomeFilterButtons.vue'

export default {
  name: 'home',
  components: {
    HomeCardList,
    HomeWeather,
    FilterButtons
  },
  mounted: function () {
    this.$store.dispatch('getAlert')
    document.body.classList.remove('scrolled')
    document.getElementById('cards').scrollTop = 0
  },
  data: function () {
    return {
      showForecast: false,
      scrollPosition: 0
    }
  },
  methods: {
    toggleForecast: function () {
      this.showForecast = !this.showForecast
    },
    handleScroll: function (e) {
      var currentScrollPosition = e.srcElement.scrollTop
      if (currentScrollPosition > 20) {
        document.body.classList.add('scrolled')
        this.showForecast = false
      } else {
        document.body.classList.remove('scrolled')
      }
      this.scrollPosition = currentScrollPosition
    },
    scrollTop: function (e) {
      document.getElementById('cards').scrollTop = 0
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/Home.vue